import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractBaseDialogFormComponent } from '../dialog/abstract-base-dialog-form-component.directive';
import { DialogComponent } from '../dialog/dialog.component';
import { TranslateModule } from '@ngx-translate/core';
import { TextareaComponent } from '../../form/textarea/textarea.component';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import { CardPickerComponent } from '../../form/card-picker/card-picker.component';
import { SelectOption } from '../../form/form-items.model';
import { take } from 'rxjs';
import { UserFeedbackSubmitReq } from '@api/model/my-api';

@Component({
  selector: 'hd-feedback-dialog',
  standalone: true,
  imports: [
    DialogComponent,
    TranslateModule,
    TextareaComponent,
    ReactiveFormsModule,
    CardPickerComponent,
  ],
  templateUrl: './feedback-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeedbackDialogComponent extends AbstractBaseDialogFormComponent {
  protected form = this.fb.group({
    rating: [undefined as unknown as number, Validators.required],
    message: ['', [Validators.required, Validators.maxLength(5000)]],
  });
  protected ratingOptions: SelectOption<number>[] = [
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
    { value: 5, label: '5' },
  ];
  protected sendData() {
    const data: UserFeedbackSubmitReq = this.form.getRawValue();

    this.api.feedback
      .submitUserFeedback(data)
      .pipe(take(1))
      .subscribe(() => {
        this.submittedSuccessfully.emit();
        this.closeRequested.emit();
      });
  }
}
